// src/pages/CartPage.js
import React from "react";
import { Box, Button, Heading, Image, Stack, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";

const CartPage = () => {
  const { cart, increaseQuantity, decreaseQuantity, removeFromCart } = useCart();
  const navigate = useNavigate();

  const getTotal = () =>
    cart.reduce((acc, item) => acc + (item.price || 0) * item.quantity, 0);

  const proceedToCheckout = () => {
    navigate("/checkout");
  };

  return (
  <Box minH="100vh" bgGradient="linear(to-br, green.50, white 80%)" py={10} px={2}>
    <Box maxW="600px" mx="auto" bg="white" borderRadius="2xl" boxShadow="2xl" p={{ base: 4, md: 8 }}>
      <Heading size="xl" mb={6} color="green.700" textAlign="center" fontWeight="extrabold">
        Your Cart
      </Heading>

      {cart.length === 0 ? (
        <Text color="gray.500" fontSize="lg" textAlign="center" mt={10}>
          No items in cart.
        </Text>
      ) : (
        <Stack spacing={6}>
          {cart.map((item) => (
            <Box
              key={item._id}
              borderWidth="1px"
              borderRadius="xl"
              p={4}
              boxShadow="md"
              bg="gray.50"
              _hover={{ boxShadow: "lg", bg: "green.50" }}
              transition="all 0.2s"
            >
              <Stack direction="row" spacing={5} align="center">
                <Image
                  boxSize="80px"
                  objectFit="cover"
                  src={item.image || "/placeholder.png"}
                  alt={item.name}
                  borderRadius="md"
                  bg="white"
                  boxShadow="sm"
                />
                <Box flex="1">
                  <Text fontWeight="bold" fontSize="lg" color="gray.800">{item.name}</Text>
                  <Text color="green.700" fontWeight="semibold" fontSize="md">
                    ₦{item.price?.toLocaleString()} x {item.quantity}
                  </Text>
                  <Stack direction="row" mt={2}>
                    <Button size="sm" onClick={() => decreaseQuantity(item._id)} variant="outline" colorScheme="green" borderRadius="md">-</Button>
                    <Text fontWeight="bold" fontSize="md">{item.quantity}</Text>
                    <Button size="sm" onClick={() => increaseQuantity(item._id)} variant="outline" colorScheme="green" borderRadius="md">+</Button>
                    <Button
                      size="sm"
                      colorScheme="red"
                      variant="ghost"
                      borderRadius="md"
                      onClick={() => removeFromCart(item._id)}
                    >
                      Remove
                    </Button>
                  </Stack>
                </Box>
              </Stack>
            </Box>
          ))}

          <Box pt={4} textAlign="center">
            <Text fontWeight="bold" fontSize="xl" color="gray.700">
              Total: <Box as="span" color="green.700">₦{getTotal().toLocaleString()}</Box>
            </Text>
            <Button
              colorScheme="green"
              size="lg"
              mt={5}
              borderRadius="xl"
              fontWeight="bold"
              boxShadow="md"
              w="100%"
              onClick={proceedToCheckout}
              _hover={{ bg: "green.600", color: "white" }}
            >
              Proceed to Checkout
            </Button>
          </Box>
        </Stack>
      )}
    </Box>
  </Box>
);
};

export default CartPage;












